import React from "react";
import CareerCard from "./CareerCard";
import { Grid } from "@mui/material";

const CareerGrid = ({ key, cardProps }) => {
  return (
    <Grid className="careerJobCard" item key={key} role="grid" aria-labelledby="career-grid-title">
      <CareerCard cardProps={cardProps} />
    </Grid>
  );
};
export default CareerGrid;
